module.exports = {
  path: 'add',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DistributionAdd'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/routes/add/index.js